<template>
  <td class="sticky-column">
    <div>{{ formatSchedule(appointmentData.schedule) }}</div>
  </td>
  <td>
    <div>{{ appointmentData.name }}</div>
  </td>
  <td>
    <div>{{ appointmentData.appointment_status }}</div>
  </td>
  <td>
    <div>{{ appointmentData.status_date }}</div>
  </td>
  <td>
    <div
      v-if="
        appointmentData.appointment_status_key == 'TK_Confirmed' &&
        !schedulePassed1Hour(appointmentData.schedule)
      "
    >
      <a :href="generateAppointmentLink(appointmentData.customer_pin)" class="pointer">
        {{ $t('AppointmentData.Link') }}
      </a>
    </div>
    <div v-else>
      {{ $t('AppointmentData.LinkNotAvailable') }}
    </div>
  </td>
  <td>
    <div class="is-flex is-justify-content-start" style="gap: 1em;">
      <button
        type="button"
        class="button is-warning is-small"
        @click="iniAppointmentData(appointmentData)"
      >
        {{ $t('General.Details') }}
      </button>
    </div>
  </td>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters, mapActions } from 'vuex';
import { Notyf } from 'notyf';

export default defineComponent({
  name: 'CustDataPetRecordTableRow',

  props: {
    appointmentData: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      notyf: new Notyf(),
      appointmentLink: process.env.BASE_URL + 'appointment/'
    };
  },

  computed: {
    ...mapGetters([
      'getShowingAppointmentData',
      'getEditedAppointmentData',
      'getAccessType'
    ])
  },

  methods: {
    ...mapActions([
      'iniEditedAppointment',
      'iniEditedAppointmentFiles',
      'toggleShowingPetRecord',
      'toggleAppointmentDetailing',
      'toggleShowingAppointmentData',
      'toggleShowingHistoricalAppointmentData'
    ]),

    formatSchedule(schedule: string): string {
      const parts = schedule.split(' ');
      const timeParts = parts[1].split(':');
      return `${parts[0]} ${timeParts[0]}:${timeParts[1]}`;
    },

    generateAppointmentLink(customerPin: string): string {
      return `${this.appointmentLink}${customerPin}?lang=${this.$i18n.locale}`;
    },

    schedulePassed1Hour(schedule: string): boolean {
      const scheduleDate = new Date(schedule);
      const now = new Date();
      const diffHours = (scheduleDate.getTime() - now.getTime()) / (1000 * 60 * 60);
      return diffHours < -1;
    },

    async iniAppointmentData(showAppointmentData: any) {
      console.log('iniAppointmentData');
      console.log(this.getShowingAppointmentData);

      await this.iniEditedAppointment(showAppointmentData.appointment_id);
      console.log('back to iniAppointmentData');
      console.log(this.getEditedAppointmentData);

      var filesStatus = 'TK_Active';
      if(this.getAccessType == 'manager')
      {
        filesStatus = 'All';
      }
      await this.iniEditedAppointmentFiles({appointmentId: showAppointmentData.appointment_id,
                                            language: this.$i18n.locale,
                                            status: filesStatus});

      this.toggleShowingPetRecord(true);
      this.toggleAppointmentDetailing(false);
      this.toggleShowingAppointmentData(false);
      this.toggleShowingHistoricalAppointmentData(false);
    }
  }
});
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.sticky-column {
  position: sticky;
  max-width: 150px;
  left: 0;
  background: #fff;
  z-index: 2;
  border-right: 1px solid #ddd;
  border-left: 1px solid #ddd;
  will-change: left;
}
</style>
